export default __webpack_public_path__ + "static/media/ic_ev_station_48px.0ddc10fb.svg";